module.exports = __webpack_public_path__ + "img/voting-up.0c387ad3.svg";